import { render, staticRenderFns } from "./bukureklasbcfrm.vue?vue&type=template&id=f6329bda"
import script from "./bukureklasbcfrm.vue?vue&type=script&lang=js"
export * from "./bukureklasbcfrm.vue?vue&type=script&lang=js"
import style0 from "./bukureklasbcfrm.vue?vue&type=style&index=0&id=f6329bda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports